/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metric_Validators_Or_Miners_NameInputs */



/**
* | output |
* | --- |
* | "Validators/Miners" |
*
* @param {Metric_Validators_Or_Miners_NameInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const metric_validators_or_miners_name = /** @type {((inputs?: Metric_Validators_Or_Miners_NameInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metric_Validators_Or_Miners_NameInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Validators/Miners")
});